<template>
    <base-layout>
        <router-view/>
    </base-layout>
</template>

<script>
    import BaseLayout from "@/blocks/base-layout/base-layout.vue"

    export default {
        name: 'App',

        components: { BaseLayout },
    }
</script>
